<div
    *transloco="let t"
    #reference
    class="tms-map-button-solo"
>
    <bazis-button
        *ngIf="{ active: active$ | async } as data"
        [color]="data.active ? 'action' : ''"
        [fill]="data.active ? 'solid' : 'clear'"
        (click)="start()"
    >
        <!-- <bazis-icon
            slot="icon-only"
            name=""
        ></bazis-icon> -->
        DP {{ data.active ? '-A' : '' }}
    </bazis-button>
    <bazis-tooltip
        [reference]="reference"
        placement="left"
        class="bh-popper-z-index"
        [isStatic]="true"
        [offset]="[-12, 0]"
        [arrow]="false"
        >{{ t('map.tooltip.drawPolygon') }}</bazis-tooltip
    >
</div>
